/**
 * @file      operation-key.js    Implementation of the OperationKey class.
 *                                Originally inside operation.js.
 * @author    Wes Garland, wes@distributive.network
 * @date      Aug 2024
 */
'use strict';

const util = require('util');
const { assert } = require('dcp/common/dcp-assert');
const { k2cCase } = require('dcp/utils');

exports.OperationKey = OperationKey;

function StringLike()
{
}
StringLike.prototype = new String();

/**
 * Creates an object which is basically a boxed String with some extra methods.
 * @constructor
 */
function OperationKey(name, parentOperationKey)
{
  this[''] = name;
  if (parentOperationKey instanceof OperationKey)
    this[''] = parentOperationKey + '.' + name;
}
OperationKey.prototype = new StringLike();
OperationKey.prototype.toString = function operationKey$$OperationKey$toString()
{
  return this[''];
}
OperationKey.prototype.valueOf = OperationKey.prototype.toString;

OperationKey.prototype[util.inspect.custom] = function operationKey$$OperationKey$inspect()
{
  return `[Object OperationKey<${this.toString()}>]`;
}

OperationKey.prototype.allows = function operationKey$$OperationKey$allows(check)
{
  const operations = require('./operations');
  assert(operations.$login);
  if (this === operations.$login) /* login is magical and allows everything */
    return true;
  if (check instanceof OperationKey)
    check = check.toString();
  if (check === this[''])
    return true;
  if (!check.startsWith(this['']))
    return false;
  return check[this[''].length] === '.';
}

OperationKey.prototype.allowedBy = function operationKey$$OperationKey$allowedBy(check)
{
  const operations = require('./operations');
  if (!(check instanceof OperationKey))
    check = findOperation(operations, check);

  if (check === operations.$login)
    return true;

  return check && check.allows(this['']);
}

/** returns {boolean} true if argument is an instance of OperationKey */
exports.isOperationKey = function isOperationKey(operationKey)
{
  return operationKey instanceof OperationKey;
}

function findOperation(parentOperationKey, operationKeyName)
{
  var lhs, rhs;
  var i = operationKeyName.indexOf('.');

  if (i === -1)
    return parentOperationKey[operationKeyName];
  else
  {
    lhs = operationKeyName.slice(0, i);
    rhs = operationKeyName.slice(i + 1);
  }

  if (!parentOperationKey[lhs])
    return null;

  if (!rhs)
    return parentOperationKey[lhs];

  return findOperation(parentOperationKey[lhs], rhs);
}

/**
 * keyPatterns.scheduler.table => create operation keys for each <table> in operationKeyNames
 * starting with jnu.scheduler.<table>
 *
 * exports.keyPatterns gets a property named for each security policy mentioned for a service defined in
 * dcp-config. Then each of those properties get the list of "tables" (security clauses) mentioned in
 * the policy.
 *
 * @todo evaluate this at webpack-time for dcp-client so that we don't need to ship entire policies
 */
if (typeof __DCP_CLIENT__ === 'undefined')
{
  const { requireNative } = require('dcp/dcp-client/webpack-native-bridge');
  const rt = requireNative('dcp/ormdb-rt');

  /* load keyPatterns from security policies in repo or /var/dcp */
  exports.keyPatterns = Object.fromEntries(
    [ 'scheduler', 'portal', 'px-auth' ]
      .map(s => [ /* key   */ k2cCase(s.replace(/-jnu/,'')) + '.jnu',
                  /* value */ { table: Object.keys(requireNative(`${rt.dirs.securityPolicy}/${s}-jnu`).securityPolicy) }])
  );
}
else
{
  /* use keyPatterns in webpack constant (which is defined by the above if-branch at webpack time!) */
  exports.keyPatterns = __DCP_PXA_OKEY_PATTERNS__; // eslint-disable-line no-undef
}
